var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAudioFormatInformation = function SvgAccessibilityAudioFormatInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M5.99 25.636a.81.81 0 0 0 .792-.81l-.007-8.988a.81.81 0 0 0-.81-.808H5.95a.81.81 0 0 0-.793.81l.007 8.988a.81.81 0 0 0 .81.808zm-.94-9.71a4.543 4.543 0 0 0 .034 9.063m18.926.647a.81.81 0 0 1-.793-.81l.01-8.988a.81.81 0 0 1 .81-.808h.016c.44.009.793.369.792.81l-.006 8.988a.81.81 0 0 1-.81.808zm.94-9.71a4.543 4.543 0 0 1-.034 9.063"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M3.323 16.037c0-6.447 5.226-11.673 11.673-11.673S26.67 9.59 26.67 16.037"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m23.314 8.25-1.21 1.074a.91.91 0 0 1-1.207.007 8.93 8.93 0 0 0-11.79-.011.91.91 0 0 1-1.202-.012L6.485 8.05"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M14.005 17.599a.3.3 0 0 0-.29.039l-1.721 1.393H10.72a.277.277 0 0 0-.274.274v2.55a.28.28 0 0 0 .274.275H12l1.721 1.393a.3.3 0 0 0 .18.055 1 1 0 0 0 .125-.024.25.25 0 0 0 .149-.242v-5.474a.38.38 0 0 0-.17-.24z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.391 17.8s1.736 2.338 0 5.145m1.947-6.437s2.61 3.514 0 7.73"
  }))));
};
export default SvgAccessibilityAudioFormatInformation;